var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleXmark1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-xmark 1",
    clipPath: "url(#clip0_2936_8327)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3358",
    cx: 14,
    cy: 14,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 28C21.7198 28 28 21.7198 28 14C28 6.28017 21.7198 0 14 0C6.28017 0 0 6.28017 0 14C0 21.7198 6.28017 28 14 28ZM9.67517 11.3248C9.219 10.8687 9.219 10.1313 9.67517 9.67517C9.90267 9.44767 10.2013 9.33333 10.5 9.33333C10.7987 9.33333 11.0973 9.44767 11.3248 9.67517L14 12.3503L16.6752 9.67517C16.9027 9.44767 17.2013 9.33333 17.5 9.33333C17.7987 9.33333 18.0973 9.44767 18.3248 9.67517C18.781 10.1313 18.781 10.8687 18.3248 11.3248L15.6497 14L18.3248 16.6752C18.781 17.1313 18.781 17.8687 18.3248 18.3248C17.8687 18.781 17.1313 18.781 16.6752 18.3248L14 15.6497L11.3248 18.3248C10.8687 18.781 10.1313 18.781 9.67517 18.3248C9.219 17.8687 9.219 17.1313 9.67517 16.6752L12.3503 14L9.67517 11.3248Z",
    fill: "#FF2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_8327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "matrix(-1 0 0 -1 28 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXmark1);
export default __webpack_public_path__ + "static/media/circle-xmark 1.59f44e21e8f3333b1601e41d1fca2c82.svg";
export { ForwardRef as ReactComponent };